(() => {
  const pause = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  async function openCookiePreferences() {
    for (let attempt = 0; attempt < 20; attempt += 1) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        await window.privacyBanner.showPreferences();
        return;
      }

      const existingControl = document.querySelector('#shopify-pc__banner__btn-manage-prefs');
      if (existingControl) {
        existingControl.click();
        return;
      }

      await pause(100);
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-yi2c-manage-cookies]');
    if (!trigger) return;
    event.preventDefault();
    openCookiePreferences();
  });
})();
